module.exports = __webpack_public_path__ + "static/media/gamma-rays.d7e3615c.svg";